enum FormType {
    Document = 'document',
    Link = 'link',
    Spacer = 'spacer',
}

export default FormType;
